import type MarketplaceSearchHit from "@travily/types/pending/models/MarketplaceSearchHit";
import { ListingCardAdapter, type ListingCardListing } from "@/components/ListingCard/ListingCardAdapter";

export interface MarketplaceHitCardProps {
  favorited?: boolean;
  hit: MarketplaceSearchHit;
  onFavoriteToggle?: () => void;
}

export function MarketplaceHitCard({ favorited, hit, onFavoriteToggle }: MarketplaceHitCardProps) {
  return (
    <ListingCardAdapter
      favorited={favorited}
      listing={hitToCardProps(hit)}
      onFavoriteToggle={onFavoriteToggle}
      showAuthor
      theme="compact"
    />
  );
}

function hitToCardProps(hit: MarketplaceSearchHit): ListingCardListing {
  const photos = (hit.photos ?? []).map((image, i) => ({
    id: `${hit.sqid}-${i}`,
    position: i,
    image,
  }));

  const account =
    hit.seller_handle != null
      ? {
          id: 0,
          handle: hit.seller_handle,
          profile_type: (hit.seller_profile_type ?? "Family") as "Family" | "Community" | "Individual",
          name: null,
          avatar: hit.seller_avatar,
          setup_completed: true,
          initial: hit.seller_initial,
          display_name: hit.seller_display_name,
          color: "red" as const,
        }
      : undefined;

  return {
    sqid: hit.sqid,
    listing_type: hit.type,
    title: hit.title,
    tagline: hit.tagline,
    description: hit.description,
    photos,
    ...(account ? { account } : {}),
    price_cents: hit.price_cents,
    price_currency: hit.price_currency,
    free: hit.free,
    average_score: hit.average_score,
    reviews_count: hit.reviews_count,
  };
}
